import { getAWSEnvironment, getAWSRegion } from '@/utils/aws/environment';
import { Amplify } from 'aws-amplify';

export function getCognitoConfig() {
  const awsEnvironment = getAWSEnvironment();
  const awsRegion = getAWSRegion();

  if (awsEnvironment === 'sso') {
    return {
      region: awsRegion,
      poolId: 'us-east-1_GDcHEV6qU',
      clientId: '5g8ua5puqimf66lbk15ju7f9ne',
    };
  } else if (awsEnvironment === 'dev') {
    return {
      region: awsRegion,
      poolId: 'us-east-2_4YQ99GNA1',
      clientId: '7n81v27crlfv6r0uh1o07alau0',
    };
  } else if (awsEnvironment === 'etsNext') {
    return {
      region: awsRegion,
      poolId: 'us-east-1_cVBkTFB0Y',
      clientId: '21jaur22dqclhu701ook99tgq2',
    };
  } else {
    throw new Error('Invalid environment supplied. No Cognito config found.');
  }
}

export function getAmplifyConfig() {
  const awsEnvironment = getAWSEnvironment();
  const awsRegion = getAWSRegion();
  const cognitoConfig = getCognitoConfig();

  const origin =
    typeof document !== 'undefined' ? document.location.origin : '';

  const domain = origin
    .replace('https://', '')
    .replace('http://', '')
    .split(':')[0];

  const amplifyConfig = {
    region: awsRegion,
    userPoolId: cognitoConfig.poolId,
    userPoolWebClientId: cognitoConfig.clientId,
    oauth: {
      domain: '',
      scope: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
      redirectSignIn: origin + '/sso',
      redirectSignOut: origin,
      responseType: 'token',
    },
    Auth: {
      cookieStorage: {
        domain, //localhost or .<domain>.com
        path: '/',
        expires: 365,
        sameSite: 'strict',
        secure: domain !== 'localhost', // Set to true if using HTTPS
      },
    },
  };

  if (awsEnvironment === 'sso') {
    amplifyConfig.oauth.domain = 'cissso.auth.us-east-1.amazoncognito.com';
  } else if (awsEnvironment === 'dev') {
    amplifyConfig.oauth.domain = 'tk421.auth.us-east-2.amazoncognito.com';
  } else if (awsEnvironment === 'etsNext') {
    amplifyConfig.oauth.domain =
      'https://us-east-1cvbktfb0y.auth.us-east-1.amazoncognito.com';

    // Override the endpoint to use FIPS for etsNext
    amplifyConfig.endpoints = [
      {
        name: 'CognitoIdentityProvider',
        endpoint: `https://cognito-idp-fips.${awsRegion}.amazonaws.com`,
      },
    ];
  } else {
    throw new Error('Invalid environment supplied. No Amplify config found.');
  }
  return amplifyConfig;
}

export function configureAmplify() {
  const amplifyConfig = getAmplifyConfig();
  if (amplifyConfig.endpoints) {
    // Explicitly configure the Auth category for FIPS in etsNext
    Amplify.configure({
      Auth: {
        region: amplifyConfig.region,
        userPoolId: amplifyConfig.userPoolId,
        userPoolWebClientId: amplifyConfig.userPoolWebClientId,
        oauth: amplifyConfig.oauth,
        endpoint: amplifyConfig.endpoints.find(
          (endpoint) => endpoint.name === 'CognitoIdentityProvider'
        )?.endpoint, // Use the FIPS endpoint
        cookieStorage: amplifyConfig.Auth.cookieStorage,
      },
      ...amplifyConfig,
      ssr: true,
    });
  } else {
    Amplify.configure({ ...amplifyConfig, ssr: true });
  }
  return amplifyConfig;
}
